import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="collapsible"
export default class extends Controller {
  static targets = ["content", "icon"];
  static values = { expanded: Boolean };

  connect() {
    this.updateDisplay();
  }

  toggle() {
    this.expandedValue = !this.expandedValue;
    this.updateDisplay();
  }

  updateDisplay() {
    if (this.expandedValue) {
      this.contentTarget.classList.remove("hidden");
      this.iconTarget.style.transform = "rotate(180deg)";
    } else {
      this.contentTarget.classList.add("hidden");
      this.iconTarget.style.transform = "rotate(0deg)";
    }
  }

  expandedValueChanged() {
    this.updateDisplay();
  }
}
